<template>
  <common-modal
    :name="modalName"
    :title="$t('schedule.add_new_schedule')"
    :primaryAction="primaryAction"
    :secondaryActions="secondaryActions"
    :onClosed="onCloseModal"
    height="auto"
    width="80%"
  >
    <template #modal-body>
      <div class="added-new-event-tabs">
        <div class="tab-header">
          <button
            class="tab-activator p-2 text-gray-700"
            :class="{ active: isSchoolEventTab }"
            @click.prevent="() => changeTab(tabNames.schoolEvent)"
          >
            {{ $t("schedule.school_event") }}
          </button>
          <button
            class="tab-activator p-2 text-gray-700"
            :class="{ active: isClassEventTab }"
            @click.prevent="() => changeTab(tabNames.classEvent)"
          >
            {{ $t("schedule.class_schedule") }}
          </button>
        </div>
        <div class="tab-content">
          <school-event-form v-if="isSchoolEventTab" ref="schoolFormRef" />
          <class-schedule-form v-if="isClassEventTab" ref="classFormRef" />
        </div>
      </div>
    </template>
  </common-modal>
</template>

<script>
import SchoolEventForm from "../Forms/SchoolEvent";
import ClassScheduleForm from "../Forms/ClassEvent/Schedule.vue";
import { EVENT_TYPES, EventAPI, REPEAT_TIMES } from "../event-utils";
import { Message } from "@/helpers/utils";
import { mapGetters } from "vuex";

const TAB_NAMES = EVENT_TYPES;

export default {
  name: "added-new-event-modal",
  components: { SchoolEventForm, ClassScheduleForm },

  data() {
    return {
      modalName: "add-new-schedule",
      primaryAction: {
        title: this.$t("common.add"),
        action: () => {
          this.handleAddNew();
        }
      },
      secondaryActions: [
        {
          title: this.$t("common.cancel"),
          action: this.hide
        }
      ],
      tabNames: TAB_NAMES,
      currentTabName: TAB_NAMES.classEvent
    };
  },
  computed: {
    ...mapGetters("user", { userTz: "timezone" }),
    isSchoolEventTab() {
      return this.currentTabName === TAB_NAMES.schoolEvent;
    },
    isClassEventTab() {
      return this.currentTabName === TAB_NAMES.classEvent;
    }
  },
  inject: ["refetchEvents"],
  methods: {
    getCurrentFormRef() {
      return this.isSchoolEventTab
        ? this.$refs.schoolFormRef
        : this.$refs.classFormRef;
    },
    open() {
      this.$modal.show(this.modalName);
    },
    hide() {
      this.$modal.hide(this.modalName);
    },
    onCloseModal() {
      //reset tab
      const formRef = this.getCurrentFormRef();
      formRef && formRef.resetEventCfg();
      this.currentTabName = TAB_NAMES.classEvent;
    },
    changeTab(tabName) {
      this.currentTabName = tabName;
    },
    handleAddNew() {
      const eventType = this.currentTabName;
      const formRef = this.getCurrentFormRef();
      const eventConfig = formRef.getEventCfg();

      if (!eventConfig.timezone) {
        eventConfig.timezone = this.userTz || "";
      }

      if (!this.validateEventCfg(eventConfig)) {
        return;
      }

      EventAPI.add({ eventType, eventConfig }).then(() => {
        this.refetchEvents();
        this.$modal.hide(this.modalName);
        Message.success(this.$t("common.successfully"));
      });
    },

    validateEventCfg(eventCfg) {
      if (this.isClassEventTab) {
        if (
          eventCfg.repeat === REPEAT_TIMES.Weekly &&
          !eventCfg.repeat_on?.length
        ) {
          Message.error(this.$t("schedule.please_set_up"));
          return false;
        }
      }

      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-activator {
  border: none;
  outline: none;
  border-radius: 3px;

  font-size: 14px;
  font-weight: 500;

  transition: 0.15s;

  &:hover {
    color: white !important;
    background: rgba(#4caf50, 0.3);
  }

  &.active {
    color: white !important;
    background: #4caf50;
  }

  & ~ .tab-activator {
    margin-left: 8px;
  }
}
</style>
